import { render } from "./newPage.vue?vue&type=template&id=2aa7b576"
import script from "./newPage.vue?vue&type=script&lang=js"
export * from "./newPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__